import { lazy } from "react";
import { ROUTE_PERMISSIONS } from "@/config/navigation";

/**
 * Hostels module routes — permissions from config/navigation.js.
 */
export const HOSTELS_ROUTES = [
  {
    path: "/hostels/dashboard",
    permission: ROUTE_PERMISSIONS["/hostels/dashboard"],
    Component: lazy(() => import("@/modules/hostels/pages/Dashboard")),
  },
  {
    path: "/hostels/manage",
    permission: ROUTE_PERMISSIONS["/hostels/manage"],
    Component: lazy(() => import("@/modules/hostels/pages/Hostels")),
  },
  {
    path: "/hostels/rooms",
    permission: ROUTE_PERMISSIONS["/hostels/rooms"],
    Component: lazy(() => import("@/modules/hostels/pages/Rooms")),
  },
  {
    path: "/hostels/layout",
    permission: ROUTE_PERMISSIONS["/hostels/layout"],
    Component: lazy(() => import("@/modules/hostels/pages/HostelLayout")),
  },
  {
    path: "/hostels/bed-sheet",
    permission: ROUTE_PERMISSIONS["/hostels/bed-sheet"],
    Component: lazy(() => import("@/modules/hostels/pages/FloorSheet")),
  },
  {
    path: "/hostels/students",
    permission: ROUTE_PERMISSIONS["/hostels/students"],
    Component: lazy(() => import("@/modules/hostels/pages/Students")),
  },
  {
    path: "/hostels/allocations",
    permission: ROUTE_PERMISSIONS["/hostels/allocations"],
    Component: lazy(() => import("@/modules/hostels/pages/Allocations")),
  },
  {
    path: "/hostels/check-in",
    permission: ROUTE_PERMISSIONS["/hostels/check-in"],
    Component: lazy(() => import("@/modules/hostels/pages/CheckIn")),
  },
  {
    path: "/hostels/gate-movements",
    permission: ROUTE_PERMISSIONS["/hostels/gate-movements"],
    Component: lazy(() => import("@/modules/hostels/pages/GateMovements")),
  },
  {
    path: "/hostels/token-desk",
    permission: ROUTE_PERMISSIONS["/hostels/token-desk"],
    Component: lazy(() => import("@/modules/hostels/pages/TokenDesk")),
  },
  {
    path: "/hostels/reservations",
    permission: ROUTE_PERMISSIONS["/hostels/reservations"],
    Component: lazy(() => import("@/modules/hostels/pages/Reservations")),
  },
  {
    path: "/hostels/reports",
    permission: ROUTE_PERMISSIONS["/hostels/reports"],
    Component: lazy(() => import("@/modules/hostels/pages/Reports")),
  },
  {
    path: "/hostels/audit",
    permission: ROUTE_PERMISSIONS["/hostels/audit"],
    Component: lazy(() => import("@/modules/hostels/pages/Audit")),
  },
  {
    path: "/hostels/leaves",
    permission: ROUTE_PERMISSIONS["/hostels/leaves"],
    Component: lazy(() => import("@/modules/hostels/pages/Leaves")),
  },
  {
    path: "/hostels/bulk-import",
    permission: ROUTE_PERMISSIONS["/hostels/bulk-import"],
    Component: lazy(() => import("@/modules/hostels/pages/BulkImport")),
  },
  {
    path: "/hostels/apply-leave",
    studentOnly: true,
    Component: lazy(() => import("@/modules/hostels/pages/ApplyLeave")),
  },
  {
    path: "/hostels/my-leaves",
    studentOnly: true,
    Component: lazy(() => import("@/modules/hostels/pages/MyLeaves")),
  },
];
